import React from 'react';

export default function TimelineConnector() {
  return (
    <div className="hidden md:flex items-center justify-center px-4">
      <div className="h-px w-full bg-gradient-to-r from-primary/50 via-primary to-primary/50" />
    </div>
  );
}